import React, { useEffect, useState } from "react";

import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    PieChart,
    Pie,
    Cell,
    BarChart,
    Bar,
    Legend
} from "recharts";

import {
    FaTrash,
    FaTriangleExclamation,
    FaBox,
    FaRecycle,
    FaPercent,
    FaDumpster
} from "react-icons/fa6";

import apiClient from "../../shared/API/apiClient";

import {
    useReportingYear
} from "../../context/ReportingYearContext";

const COLORS = [
    "#ef4444",
    "#2563eb",
    "#10b981",
    "#f59e0b",
    "#8b5cf6"
];
const SITE_COLORS = [
    "#2563eb",
    "#10b981",
    "#f59e0b",
    "#ef4444",
    "#8b5cf6",
    "#06b6d4",
    "#84cc16",
    "#f97316",
    "#14b8a6",
    "#ec4899"
];
const ICONS = {
    total: FaTrash,
    hazardous: FaTriangleExclamation,
    non_hazardous: FaBox,
    diverted: FaRecycle,
    rate: FaPercent,
    landfill: FaDumpster
};

const formatNumber = value => {

    if(
        value === null ||
        value === undefined ||
        value === ""
    ) {
        return "-";
    }

    return Number(value).toLocaleString(
        "en-IN",
        {
            maximumFractionDigits: 2
        }
    );
};

const WasteAnalysisPage = () => {

    const { reportingYear, reportingYearId } = useReportingYear();
    const [reportingYearInfo, setReportingYearInfo] =useState(null);
    const [loading, setLoading] = useState(false);
    const [report, setReport] = useState(null);
    const [legalEntities, setLegalEntities] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState("");

    // =====================================
    // ENTITY
    // =====================================
useEffect(() => {

   const loadReportingYear = async () => {

    try {

        const res =
            await apiClient.post(
                "/api/reportingyear"
            );

        if (res.data.code === 200) {

            const selected =
                (res.data.data || [])
                    .find(
                        y =>
                            Number(y.id) ===
                            Number(reportingYearId)
                    );

            setReportingYearInfo(
                selected || null
            );
        }

    } catch (e) {

        console.error(
            "Reporting year API error:",
            e
        );
    }
};

    loadReportingYear();

}, [reportingYearId]);
    useEffect(() => {

        const load = async () => {

            if(!reportingYearId) {
                return;
            }

            try {

                const res =
                    await apiClient.get(
                        "/api/legal-entities-by-year",
                        {
                            params: {
                                reporting_year_id:
                                    reportingYearId
                            }
                        }
                    );

                setLegalEntities(
                    res.data.data || []
                );

            } catch {

                setLegalEntities([]);
            }
        };

        load();

    }, [reportingYearId]);

    // =====================================
    // FILTER
    // =====================================

    const [filters, setFilters] =
        useState({
            filter_type: "THIS_YEAR",
            quarter: "",
            month: "",
            from_date: "",
            to_date: ""
        });

      const handleFilterChange = (field, value) => {

    const updated = {
        ...filters,
        [field]: value
    };

    if(field === "filter_type") {

        updated.quarter = "";
        updated.month = "";

        if(value === "CUSTOM" && reportingYearInfo) {
            updated.from_date =
                reportingYearInfo.start_date;

            updated.to_date =
                reportingYearInfo.end_date;
        }

        if(value !== "CUSTOM") {
            updated.from_date = "";
            updated.to_date = "";
        }
    }

    setFilters(updated);
};

    // =====================================
    // LOAD
    // =====================================

    const loadReport = async () => {

        if(
            !reportingYearId ||
            !selectedEntity
        ) {
            return;
        }

        try {

            setLoading(true);

            const response =
            await apiClient.get(
                "/api/reports/waste-analysis-dashboard",
                {
                    params: {

                        reporting_year_id:
                            reportingYearId,

                        legal_entity_id:
                            selectedEntity,

                        ...filters
                    }
                }
            );

        setReport(response.data);

        } finally {

            setLoading(false);
        }
    };

    useEffect(() => {

        loadReport();

    }, [
        reportingYearId,
        selectedEntity
    ]);

    if(loading) {

        return (
            <div className="dash-loader-wrapper">
                <div className="dash-loader" />
            </div>
        );
    }
    return (

    <div className="dash-page">

        <div className="dash-page-title">
            Waste Performance
        </div>

        <div className="dash-page-subtitle">
             Waste generation, diversion and disposal analysis
        </div>

        {/* FILTER */}

        <div className="filter-card">

            

            <div className="filter-group">

                <label>
                    Legal Entity
                </label>

                <select
                    className="filter-fields"
                    value={selectedEntity}
                    onChange={e => setSelectedEntity(e.target.value)}
                >

                    <option value="">
                        Select
                    </option>

                    {
                        legalEntities.map(e => (
                            <option
                                key={e.entity_id}
                                value={e.entity_id}
                            >
                                {e.entity_name}
                            </option>
                        ))
                    }

                </select>

            </div>

            <div className="filter-group">

                    <label>Period</label>

                    <select
                        className="filter-fields"
                        value={filters.filter_type}
                        onChange={e => handleFilterChange("filter_type", e.target.value)}
                    >
                        <option value="THIS_YEAR">This Year</option>
                        <option value="THIS_QUARTER">Quarter</option>
                        <option value="THIS_MONTH">Month</option>
                        <option value="CUSTOM">Custom</option>
                    </select>

                </div>
                    {
                                    filters.filter_type === "THIS_QUARTER" && (
                        <div className="filter-group">

                            <label>Quarter</label>

                            <select
                                className="filter-fields"
                                value={filters.quarter}
                                onChange={e => handleFilterChange("quarter", e.target.value)}
                            >
                                <option value="">Select Quarter</option>
                                <option value="1">Q1</option>
                                <option value="2">Q2</option>
                                <option value="3">Q3</option>
                                <option value="4">Q4</option>
                            </select>

                        </div>
                    )
                }

                {
                    filters.filter_type === "THIS_MONTH" && (
                        <div className="filter-group">

                            <label>Month</label>

                            <select
                                className="filter-fields"
                                value={filters.month}
                                onChange={e => handleFilterChange("month", e.target.value)}
                            >

                                <option value="">Select Month</option>

                                {
                                    (() => {

                                        const months = [];

                                        const start = new Date(
                                            report?.reporting_period?.from_date ||
                                            `${new Date().getFullYear()}-04-01`
                                        );

                                        const current = new Date();
                                        const temp = new Date(start);

                                        while(
                                            temp.getFullYear() < current.getFullYear() ||
                                            (
                                                temp.getFullYear() === current.getFullYear() &&
                                                temp.getMonth() <= current.getMonth()
                                            )
                                        ) {

                                            const year = temp.getFullYear();

                                            const month = String(
                                                temp.getMonth() + 1
                                            ).padStart(2, "0");

                                            months.push({
                                                value: `${year}-${month}`,
                                                label: temp.toLocaleString(
                                                    "en-IN",
                                                    {
                                                        month: "short",
                                                        year: "numeric"
                                                    }
                                                )
                                            });

                                            temp.setMonth(
                                                temp.getMonth() + 1
                                            );
                                        }

                                        return months.map(item => (
                                            <option
                                                key={item.value}
                                                value={item.value}
                                            >
                                                {item.label}
                                            </option>
                                        ));
                                    })()
                                }

                            </select>

                        </div>
                    )
                }

                {
                    filters.filter_type === "CUSTOM" && (
                        <>
                            <div className="filter-group">

                                <label>
                                    From
                                </label>

                                <input
                                    type="date"
                                    className="filter-fields"
                                    min={
                                        reportingYearInfo?.start_date
                                    }
                                    max={
                                        reportingYearInfo?.end_date
                                    }
                                    value={filters.from_date}
                                    onChange={(e) =>
                                        handleFilterChange(
                                            "from_date",
                                            e.target.value
                                        )
                                    }
                        />

                            </div>

                            <div className="filter-group">

                                <label>
                                    To
                                </label>

                                <input
                                        type="date"
                                        className="filter-fields"
                                        min={
                                            reportingYearInfo?.start_date
                                        }
                                        max={
                                            reportingYearInfo?.end_date
                                        }
                                        value={filters.to_date}
                                        onChange={(e) =>
                                            handleFilterChange(
                                                "to_date",
                                                e.target.value
                                            )
                                        }
                                    />

                            </div>
                        </>
                    )
                }
                <div className="filter-group">

                    <label>&nbsp;</label>

                    <button className="org-btn-save" onClick={loadReport}>
                        Generate Report
                    </button>

                </div>

        </div>
        {
                !report && (

                    <div className="empty-entity">
          <div className="empty-entity__icon"><i className="fa-solid fa-building" /></div>
          <div className="empty-entity__title">Select a Legal Entity to continue</div>
          <div className="empty-entity__sub">
            Select a legal entity to analyze waste generation, diversion and disposal trends.
          </div>
        
        </div>
                )
            }

        {
            report &&(() => {

                const {
                        applied_filter,
                        summary,
                        kpis,
                        waste_distribution,
                        waste_type_distribution,
                        monthly,
                        sitewise,
                        features,
                        hazardous_percent,
                        non_hazardous_percent
                    } = report;

                return (

                    <>

                        <div className="reporting_year_line">
                            <strong>{applied_filter.label}</strong> | {applied_filter.from_date} to {applied_filter.to_date}
                        </div>
                        {/* KPI */}

                        <div className="dash-stat-grid" style={{
                                    gridTemplateColumns:
                                        `repeat(${kpis.length},1fr)`
                                }}>

                            {
                                kpis.map(kpi => {
                                    const Icon = ICONS[kpi.key];

                                    return (
                                        <div key={kpi.key} className="dash-stat-card">

                                            <div className="dash-stat-header">
                                            <span className="metric-card__icon">
                                                <Icon />
                                                </span>
                                                <div className="dash-stat-label">{kpi.title}</div>
                                            </div>

                                            <div className="dash-stat-value">{kpi.value}</div>

                                            <div className="dash-stat-sub">{kpi.unit}</div>

                                        </div>
                                    );
                                })
                            }

                        </div>
                        <div className="management-summary">

    <div className="management-summary-title">Management Insights</div>

    <div className="management-summary-grid">

        <div className="management-summary-card">
            <div className="summary-label">Top Waste Stream</div>
            <div className="summary-value">{report.summary.top_waste_stream}</div>
            <div className="summary-sub">
                {formatNumber(report.waste_distribution?.sort((a, b) => b.value - a.value)[0]?.percent)}% of total waste
            </div>
        </div>

        <div className="management-summary-card">
            <div className="summary-label">Largest Waste Generator</div>
            <div className="summary-value">{report.summary.top_site}</div>
            <div className="summary-sub">Highest contribution site</div>
        </div>

        <div className="management-summary-card">
            <div className="summary-label">Waste Diversion</div>
            <div className={report.summary.diversion_rate > 50 ? "summary-value success" : "summary-value danger"}>
                {report.summary.diversion_rate}%
            </div>
            <div className="summary-sub">Diverted from landfill</div>
        </div>

    </div>

</div>
                        <div className="chart-row">
                        {
                        features.show_waste_distribution && (
                            <div className="chart-card">
                                <h4>Waste Stream Distribution</h4>
                                <ResponsiveContainer width="100%" height={320}>
                                    <PieChart>
                                        <Pie data={waste_distribution} dataKey="value" nameKey="name" outerRadius={100} label>
                                            {waste_distribution.map((item, index) => (
                                                <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Pie>
                                        <Tooltip />
                                    </PieChart>
                                </ResponsiveContainer>
                            </div>
                        )
                    }
                    {
                        features.show_type_distribution && (
                            <div className="chart-card">
                                <h4>Hazardous vs Non-Hazardous</h4>
                                <ResponsiveContainer width="100%" height={320}>
                                    <PieChart>
                                        <Pie data={waste_type_distribution} dataKey="value" nameKey="name" outerRadius={100} label>
                                            <Cell fill="#ef4444" />
                                            <Cell fill="#10b981" />
                                        </Pie>
                                        <Tooltip />
                                    </PieChart>
                                </ResponsiveContainer>
                                <div className="chart-summary">
                                    Hazardous: {formatNumber(hazardous_percent)}% {" | "}
                                    Non-Hazardous: {formatNumber(non_hazardous_percent)}%
                                </div>
                            </div>
                        )
                    }
                        
                    </div>
                    <div className="chart-row">
                            {
                                features.show_monthly_chart && (
                                    <div className="chart-card">
                                        <h4>Monthly Waste Trend</h4>
                                        <ResponsiveContainer width="100%" height={350}>
                                            <LineChart data={monthly}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="month" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                <Line type="monotone" dataKey="generated" stroke="#2563eb" />
                                                <Line type="monotone" dataKey="diverted" stroke="#10b981" />
                                                <Line type="monotone" dataKey="landfill" stroke="#ef4444" />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>
                                )
                            }
                        
                        {
                        features.show_site_chart && (
                            <div className="chart-card">
                                <h4>Site Waste Contribution</h4>
                                <ResponsiveContainer width="100%" height={350}>
                                    <BarChart data={sitewise}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="site_name" />
                                        <YAxis />
                                        <Tooltip />
                                        <Bar dataKey="waste_generated">
                                            {sitewise.map((item, index) => (
                                                <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        )
                    }
                        </div>
                        {
                            features.show_site_table && (
                                <div className="table-card">
                                    <h4>Site Wise Waste Analysis</h4>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Site</th>
                                                <th>Total</th>
                                                <th>Hazardous</th>
                                                <th>Non Hazardous</th>
                                                <th>Contribution</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sitewise.map((row, index) => (
                                                <tr key={index}>
                                                    <td>{row.site_name}</td>
                                                    <td>{formatNumber(row.waste_generated)}</td>
                                                    <td>{formatNumber(row.hazardous)}</td>
                                                    <td>{formatNumber(row.non_hazardous)}</td>
                                                    <td>{row.contribution_percent}%</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )
                        }

                    </>
                );
            })()
        }

                    </div>
            );
            };

export default WasteAnalysisPage;